import React, { PureComponent, PropTypes } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect'
import { calculate, addRow } from  '../../redux/actions';
import { selectHydrated as cartSelector } from  '../../redux/modules/cart/selectors';
import { selectSubjectOptions } from  '../../redux/modules/subjects/selectors';
import Form from './Form';


class ProductBasket extends PureComponent {
  static propTypes = {
    subjects: PropTypes.array.isRequired,
    calculate: PropTypes.func.isRequired,
    addRow: PropTypes.func.isRequired,
    result: PropTypes.object,
    product: PropTypes.object.isRequired,
    disabledPeriods: PropTypes.array.isRequired,
    prevPayload: PropTypes.object
  };

  static contextTypes = {
    user: PropTypes.object
  }

  constructor(props) {
    super(props);
    this.calculate = this.calculate.bind(this);
    this.addRow = this.addRow.bind(this);
    const { product, prevPayload } = this.props;

    // We want to restore initial valus for same product
    if (prevPayload && prevPayload.product === product.id) { 
        this.state = {
          initialValues: prevPayload,
        };
    } else {
      this.state = {
        initialValues: { product: product.id, subject: "", dateFrom: "", dateTo: ""},
      };
    }
  }
  componentWillReceiveProps(nextProps, nextState) {
    const { product, prevPayload } = nextProps;

    if (this.props.product.id === nextProps.product.id) {
      return 
    }
    // We want to restore initial valus for same product
    if (prevPayload && prevPayload.product === product.id) { 
        this.state = {
          initialValues: prevPayload,
        };
    } else {
      this.state = {
        initialValues: { product: product.id, subject: "", dateFrom: "", dateTo: ""},
      };
    }
  }

  componentDidMount() {
    if (!this.state.fresh) {
      this.props.calculate(this.state.initialValues);
    } else {
      this.props.calculate(null);
    }
  }


  addRow(row) {
    this.props.addRow(row).then(this.form.reset());
  }

  calculate(row) {
    this.props.calculate(row);
  }

  render() {
    const {
      product,
      subjects,
      disabledPeriods,
      calculating,
      result
    } = this.props;

    const { user } = this.context;
  

    const props = {
      calculate: this.calculate,
      initialValues: this.state.initialValues,
      product,
      subjects,
      disabledPeriods,
      calculating,
      result,
      user,
      onSubmit: this.addRow
    };

    return (
      <div className="basket-container">
        <h4>Projekta izmaksas</h4>
        <p>Lai sagatavotu precīzu tāmi (summas bez PVN), izvēlies reklāmas periodu un nozari! Pievieno grozam!</p>
        <p><sup>*</sup> Izmaksu prognoze 30 dienām (noma, nodeva, drukas un eksponēšanas izmaksas, <strong>bez</strong> PVN)</p>
        <Form {...props } ref={r => this.form = r}/>
      </div>
    )
  }
}

import moment from 'moment';
import  { SERIALIZATION_FORMAT } from '../../components/PeriodPicker';

const rawProductPeriodSelector = (state, props) => props.product ? props.product.periods : [];
const productPeriodSelector = createSelector(
  [rawProductPeriodSelector],
  periods => periods.map(p => ({
    from: moment(p.dateFrom, SERIALIZATION_FORMAT).toDate(),
    to: moment(p.dateTo, SERIALIZATION_FORMAT).toDate() 
  }))
);

const cartPeriodSelector = (state, props) => {
  const cart = cartSelector(state);
  return cart ? cart.items
    .filter(item => item.product.id === props.product.id)
    .map(item => ({
      from: moment(item.dateFrom, SERIALIZATION_FORMAT).toDate(),
      to: moment(item.dateTo, SERIALIZATION_FORMAT).toDate() 
    })) : [];
}


const disabledPeriods = createSelector(
  [productPeriodSelector, cartPeriodSelector],
  (productPeriods, cartPeriods) => [...productPeriods, ...cartPeriods]
);


const mapStateToProps = (state, props) => ({
  subjects: selectSubjectOptions(state),
  prevPayload: state.basket.prevPayload,
  disabledPeriods: disabledPeriods(state, props),
  ...state.basket
});

const ConnectedBasket = connect(mapStateToProps, {calculate, addRow })(ProductBasket);
export default ConnectedBasket


// WEBPACK FOOTER //
// ./src/containers/ProductBasket/index.js